import { Component } from "react";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import { getDelagateCircularCompany_action, getDelagateCircularList_action, insertUpdateDelagateCircular_action, delDelagateCircular_action, assignCircular_action } from "../../../actions/admin_module_action/delegate_Circular_action/delegate_Circular_action";
import { exhibitorTypeActionId, paymentTypeActionId, toastError, toastSuccess, DOC_BASE_URL } from "../../../utils/constants";
import { data } from "jquery";
import Pagination from "../../../utils/pagination";
import DatePicker from "react-datepicker";
import Resizer from "react-image-file-resizer";
import Modal from "react-modal";
import { fill_action } from "../../../actions/fillCombo_action";
import ConfirmationModal from "../../../common_components/confirmationa_modal";


class AddDelegateCircular extends Component {
    // Initialized 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            companyList: [],
            circularSearch: '',
            currentPage: 1,
            circularList: [],
            circularDate: "",
            circularTitle: "",
            circularFile: "",
            circularFileType: "",
            checkedAll: false,
            selectedCompany: [],
            isDelOpen: false,
            circularID: "",
            companyName: "",
            paymentTypeId: "",
            exhibitorTypeId: "",
            paymentTypeList: [],
            exhibitorTypeList: [],
            loginAccesslist: [],

            // Err Messages
            circularDateErr: "",
            circularTitleErr: "",
            circularFileErr: "",

            isSendMail: false,
            circularFileName: '',
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
        }
        this.getCircularCompany = this.getCircularCompany.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.getCircularList = this.getCircularList.bind(this)
        this.insertCircular = this.insertCircular.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.selectAllCompany = this.selectAllCompany.bind(this)
        this.handleCheckedCompany = this.handleCheckedCompany.bind(this)
        this.delCircular = this.delCircular.bind(this)
        this.toggleDelModal = this.toggleDelModal.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this)
        this.getWirteAccess = this.getWirteAccess.bind(this)
        this.getDeleteAccess = this.getDeleteAccess.bind(this)
        this.checkedCirculars = this.checkedCirculars.bind(this)
        this.assignCircular = this.assignCircular.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
    }

    // Om Component Load
    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(paymentTypeActionId, '', '', '', '', '');
        this.getFillList(exhibitorTypeActionId, '', '', '', '', '');
        this.getCircularCompany()
        this.getCircularList()
    }

    // Get Circular Company 
    getCircularCompany() {
        const { paymentTypeId, exhibitorTypeId, companyName } = this.state
        this.setState({ isLoading: true })
        this.props.getDelagateCircularCompany_action(paymentTypeId != "" && paymentTypeId != "Select Payment Type" ? paymentTypeId : "",
            exhibitorTypeId != "" && exhibitorTypeId != "Select Exhibitor Type" ? exhibitorTypeId : "", companyName
        )
            .then((data) => {
                if (data.error != 1) {
                    data.data.length > 0 && data.data.map((item) => {
                        item.Is_Select = false
                    })
                    console.log("getCircularCompany Data", data.data)
                    this.setState({
                        companyList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // Update Current Page
    updateItem(item) {
        const { companyList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = companyList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(companyList.length / recordsPerPage)
    }

    // Get Circular List
    getCircularList() {
        this.setState({ isLoading: true })
        this.props.getDelagateCircularList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("getCircularList Data", data.data)
                    data.data.length > 0 && data.data.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        circularList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // Insert Circular 
    insertCircular(e) {
        const { circularDate, circularFile, circularTitle, circularDateErr, circularFileErr, isSendMail, circularTitleErr, companyList, circularFileType, circularID } = this.state
        this.inputValidate()
        // var selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
        if (circularDate != "" && circularTitle != "" && circularFile != "") {
            if (circularDateErr == "" && circularTitleErr == "" && circularFileErr == "") {
                var selectedCompany = []
                selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
                if (selectedCompany.length > 0) {
                    // circular data Preparing to store
                    var list = []
                    selectedCompany.map(data => {
                        var mapData = {
                            'AccountID': parseInt(data.AccountID),
                            'DelegateRegistrationID': parseInt(data.DelegateRegistrationID),
                        }
                        list.push(mapData)
                    });

                    this.setState({ isLoading: true })
                    this.props.insertUpdateDelagateCircular_action(circularID, circularDate, circularTitle, circularFile, list, circularFileType, isSendMail)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({ isLoading: false })
                                toastSuccess("Circular Added Successfully")
                                // this.props.navigate('/addcircular')
                                // window.location.reload()
                                this.getCircularCompany()
                                this.getCircularList()
                                this.handleClear()
                            } else {
                                this.setState({ isLoading: false })
                                toastError(data.msg)
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                } else {
                    toastError("Please Select Atleast One Company")
                }
            } else {
                toastError("Please Fill Mandatory Input Fields")
            }
        } else {
            toastError("Please Fill Mandatory Input Fields")
        }



    }

    // Input Feilds Validation
    inputValidate() {
        const { circularDate, circularTitle, circularFile } = this.state

        if (circularDate == "") {
            this.setState({ circularDateErr: 'Please Select Circular Date' })
        }
        if (circularTitle == "") {
            this.setState({ circularTitleErr: 'Please Enter Circular Title' })
        }
        if (circularFile == "") {
            this.setState({ circularFileErr: 'Please Select Circular File' })
        }
    }

    // On Cicular File Select
    onFilePick = async (e, file) => {
        e.preventDefault()
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                this.setState({
                    circularFile: '',
                    circularFileType: '',
                    // passportFileType: '',
                    // passportFilePath: '',
                })
                document.getElementById("circularFile").value = ""
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf')

                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        this.setState({ circularFile: image, circularFileName: file[0]['name'], circularFileErr: '' })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ circularFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                } else {
                    toastError('Only .pdf files are allowed')
                    this.setState({
                        circularFile: '',
                        circularFileType: '',
                        circularFileName: '',
                        // passportFileType: '',
                        // passportFilePath: '',
                    })
                    document.getElementById("circularFile").value = ""
                }
            }
        } else {
            this.setState({
                circularFile: '',
                circularFileType: '',
                // passportFileType: '',
                // passportFilePath: '',
            })
            document.getElementById("circularFile").value = ""
        }
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    //on Select All Click
    selectAllCompany(e) {
        const { checkedAll, companyList } = this.state
        this.setState({ checkedAll: !checkedAll })
        const checked = e.target.checked
        companyList.length > 0 && companyList.map((data) => {
            if (checked) {
                data.Is_Select = true
            } else {
                data.Is_Select = false
            }
        })
        console.log("yyyyyyyyyyyyy", companyList)
        this.setState({ selectedCompany: companyList })
    }

    // On Checked Company
    handleCheckedCompany(e, id) {
        const { companyList, selectedCompany } = this.state
        const checked = e.target.checked

        companyList.length > 0 && companyList.map((data) => {
            if (data.DelegateRegistrationID == id) {
                if (checked) {
                    data.Is_Select = true
                } else {
                    data.Is_Select = false
                    this.setState({ checkedAll: false })
                }
            }
        })
        this.setState({})
    }

    // On Delete Circular
    delCircular(e) {
        const { circularID } = this.state
        this.setState({ isLoading: true })
        this.props.delDelagateCircular_action(circularID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        isDelOpen: false,
                        isLoading: false
                    })
                    toastSuccess("Circular Deleted Successfully")
                    this.handleClear()
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    //toggle for delete
    toggleDelModal(id) {
        const { isDelOpen } = this.state
        console.log("id-------->", id)
        this.setState({
            isDelOpen: !isDelOpen, circularID: id
        })
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // Payment Type list
                    if (actionID === paymentTypeActionId) {
                        console.log("Payment Type list data", data.data)
                        this.setState({
                            paymentTypeList: data.data.length > 0 ? data.data : [],
                            isLoading: false
                        })
                    }
                    // Exhibitor Type list
                    if (actionID === exhibitorTypeActionId) {
                        console.log("Exhibitor Type list data", data.data)
                        this.setState({
                            exhibitorTypeList: data.data.length > 0 ? data.data : [],
                            isLoading: false
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // On Search Click
    onSearchClick() {
        this.getCircularCompany()
        setTimeout(() => {
            this.setState({
                currentPage: 1
            })
        }, 200);
    }

    getWirteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '14');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '14');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    checkedCirculars(e, id) {
        const { circularList } = this.state
        const checked = e.target.checked

        circularList.length > 0 && circularList.map((data) => {
            if (data.DelegateCircularID == id) {
                if (checked) {
                    data.isSelect = true
                } else {
                    data.isSelect = false
                }
            }
        })
        console.log("aaaaaaaaaaa", circularList)
        this.setState({})
    }

    assignCircular() {
        const { circularList, companyList } = this.state
        var selectedCompany = []
        selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
        var selectedCircular = []
        selectedCircular = circularList.length > 0 && circularList.filter((item) => item.isSelect == true)

        if (selectedCircular.length > 0) {
            if (selectedCompany.length > 0) {
                // circular User data Preparing to store
                var list = []
                selectedCompany.map(data => {
                    var mapData = {
                        'AccountID': parseInt(data.AccountID),
                    }
                    list.push(mapData)
                });
                // circular data Preparing to store
                var list2 = []
                selectedCircular.map(data => {
                    var mapData = {
                        'CircularID': parseInt(data.DelegateCircularID),
                    }
                    list2.push(mapData)
                });
                this.setState({ isLoading: true })
                this.props.assignCircular_action(list, list2, 0, this.state.isSendMail)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false, isSendMail: false })
                            toastSuccess("Circular Assign Successfully")
                            this.handleClear()
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please Select Atleast One Exhibitor")
            }
        } else {
            toastError("Please Select Atleast One Circular")
        }
    }

    handleClear() {
        const { companyName, paymentTypeId, isSendMail, exhibitorTypeId } = this.state

        this.setState({
            companyName: '',
            // paymentTypeId: "",
            exhibitorTypeId: "",
            circularFileName: '',
            currentPage: 1,
            circularDate: '',
            circularTitle: '',
            circularFile: '',
            circularFileType: '',
            checkedAll: false,
            isSendMail: false,
        })
        document.getElementById("circularFile").value = ""
        setTimeout(() => {
            this.getCircularCompany()
            this.getCircularList()
        }, 200);
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '14');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.insertCircular()
            }
            if (confirmationObj.action == 1) {
                this.assignCircular()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }


    render() {
        const { isLoading, companyList, currentPage, circularDate, circularTitle, circularDateErr, circularTitleErr, circularFileErr,
            checkedAll, circularList, isDelOpen, companyName, paymentTypeId, exhibitorTypeId, paymentTypeList, exhibitorTypeList, isOpenConfirmationModal,
            circularFileName
        } = this.state

        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = companyList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(companyList.length / recordsPerPage)

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}

                <HeaderWithLogo />
                <AdminDrawer />

                <div className="main-content app-content with-dr-container">
                    <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 py-2 px-3 text-white">Delegate Circular</h6>
                            </div>
                        </div>
                    </div>
                    <main id="main" className="px-3 dc-page">
                        <section className="section p-0">
                            <div className="admin-top-space pt-0 pb-3">
                                <div className="row g-3">
                                    {/* Add Circular */}
                                    <div className="col-lg-6">
                                        <div className="dc-card h-100">
                                            <div className="dc-card-head">
                                                <h6 className="dc-card-title"><i className="fa fa-user"></i> Add Circular</h6>
                                            </div>
                                            <div className="dc-card-body">
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <label className="dc-label">Circular Name<span className="text-danger"> *</span></label>
                                                        <div className="dc-input-icon">
                                                            <i className="fa fa-file-text-o"></i>
                                                            <input type="text" className="form-control"
                                                                placeholder="Enter circular name"
                                                                value={circularTitle}
                                                                onInput={toInputUppercase}
                                                                onChange={(e) => this.setState({ circularTitle: e.target.value, circularTitleErr: "" })}
                                                            />
                                                        </div>
                                                        {circularTitleErr && <span className='text-danger d-block mt-1'>{circularTitleErr}</span>}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="dc-label">Circular Date<span className="text-danger"> *</span></label>
                                                        <div className="dc-input-icon dc-input-icon-end">
                                                            <DatePicker
                                                                selected={circularDate}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                onChange={(date) => this.setState({ circularDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), circularDateErr: "" })}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="Select circular date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            <i className="fa fa-calendar"></i>
                                                        </div>
                                                        {circularDateErr && <span className='text-danger d-block mt-1'>{circularDateErr}</span>}
                                                    </div>
                                                    <div className="col-12">
                                                        <label className="dc-label">Upload Circular<span className="text-danger"> *</span></label>
                                                        {circularFileName != "" ? (
                                                            <div className="dc-file">
                                                                <span className="dc-file-name"><i className="fa fa-paperclip"></i> {circularFileName}</span>
                                                                <button type="button" className="dc-file-btn dc-file-remove" title="Remove file"
                                                                    onClick={() => this.setState({ circularFile: '', circularFileName: '', circularFileType: '' })}
                                                                ><i className="fa fa-times"></i></button>
                                                            </div>
                                                        ) : (
                                                            <label className="dc-file mb-0">
                                                                <span className="dc-file-name text-muted"><i className="fa fa-paperclip"></i> Choose a PDF file</span>
                                                                <span className="dc-file-btn">Browse</span>
                                                                <input type="file" accept=".pdf" className="d-none"
                                                                    onChange={e => this.onFilePick(e, e.target.files)}
                                                                />
                                                            </label>
                                                        )}
                                                        {circularFileErr && <span className='text-danger d-block mt-1'>{circularFileErr}</span>}
                                                        <div className="dc-note mt-2"><i className="fa fa-info-circle"></i> Only .pdf files are allowed, with a maximum size of 5mb</div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <button type="button" className="btn dc-btn-outline w-100"
                                                            disabled={!this.getWriteAccess()}
                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                                                        ><i className="fa fa-plus me-2"></i>Add Circular</button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <button type="button" className="btn dc-btn-solid w-100"
                                                            disabled={!this.getWriteAccess()}
                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Assign?`, buttonName: "Assign", action: 1 }, popArg: [] })}
                                                        ><i className="fa fa-users me-2"></i>Assign Circular</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* All Circulars */}
                                    <div className="col-lg-6">
                                        <div className="dc-card h-100">
                                            <div className="dc-card-head">
                                                <h6 className="dc-card-title"><i className="fa fa-file-text"></i> All Circulars</h6>
                                                <div className="dc-input-icon dc-search">
                                                    <i className="fa fa-search"></i>
                                                    <input type="text" className="form-control form-control-sm" placeholder="Search circulars..."
                                                        value={this.state.circularSearch || ''}
                                                        onChange={(e) => this.setState({ circularSearch: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="dc-card-body dc-circular-list">
                                                {circularList.filter(d => !this.state.circularSearch || String(d.CircularDescription || '').toLowerCase().includes(this.state.circularSearch.toLowerCase())).map((data) => (
                                                    <div className="dc-circular" key={data.DelegateCircularID}>
                                                        <input type="checkbox" className="form-check-input m-0"
                                                            checked={data.isSelect}
                                                            onChange={(e) => this.checkedCirculars(e, data.DelegateCircularID)}
                                                        />
                                                        <span className="dc-pdf"><i className="fa fa-file-pdf-o"></i></span>
                                                        <div className="dc-circular-text">
                                                            <div className="dc-circular-title">
                                                                {data.CircularDescription}
                                                                <i className="fa fa-info-circle dc-info" title="View History"
                                                                    onClick={() => this.openHistoryModal(data.DelegateCircularID, data.CircularDescription)}
                                                                />
                                                            </div>
                                                            {data.CircularDate && <div className="dc-circular-date"><i className="fa fa-calendar-o"></i> {new Date(data.CircularDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</div>}
                                                        </div>
                                                        <div className="dc-circular-actions">
                                                            {data.Attachment && <a className="dc-act" title="Download" href={DOC_BASE_URL + data.Attachment} target="_blank" rel="noopener noreferrer"><i className="fa fa-download"></i></a>}
                                                            <button type="button" className="dc-act dc-act-del" title="Delete"
                                                                disabled={!this.getDeleteAccess()}
                                                                onClick={() => this.getDeleteAccess() && this.toggleDelModal(data.DelegateCircularID)}
                                                            ><i className="fa fa-trash"></i></button>
                                                        </div>
                                                    </div>
                                                ))}
                                                {circularList.length == 0 && <p className="text-muted text-center my-4">No circulars yet.</p>}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Assign Circular to Exhibitors */}
                                    <div className="col-12">
                                        <div className="dc-card">
                                            <div className="dc-card-head">
                                                <div>
                                                    <h6 className="dc-card-title"><i className="fa fa-users"></i> Assign Circular to Exhibitors</h6>
                                                    <div className="dc-card-sub">Search and select companies to assign the circular</div>
                                                </div>
                                            </div>
                                            <div className="dc-card-body">
                                                <div className="filter-grid mb-3">
                                                    <div>
                                                        <label className="dc-label">Company Name</label>
                                                        <div className="dc-input-icon">
                                                            <i className="fa fa-search"></i>
                                                            <input type="text" className="form-control" placeholder="Search Company"
                                                                value={companyName}
                                                                onChange={(e) => this.setState({ companyName: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label className="dc-label">Category</label>
                                                        <select className="form-control" value={paymentTypeId}
                                                            onChange={(e) => this.setState({ paymentTypeId: e.target.value })}
                                                        >
                                                            <option value={0}>Select Category</option>
                                                            {paymentTypeList.length > 0 && paymentTypeList.map((data) => (
                                                                <option key={data.ID} value={data.ID}>{data.PaymentType}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className="dc-label">Exhibitor Type</label>
                                                        <select className="form-control" value={exhibitorTypeId}
                                                            onChange={(e) => this.setState({ exhibitorTypeId: e.target.value })}
                                                        >
                                                            <option>Select Exhibitor Type</option>
                                                            {exhibitorTypeList.length > 0 && exhibitorTypeList.map((data) => (
                                                                <option key={data.ID} value={data.ID}>{data.ExhibitorType}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="filter-actions">
                                                        <button className="btn btn-aqua" onClick={(e) => this.onSearchClick()}><i className="fa fa-search me-1"></i>Search</button>
                                                        <button className="btn dc-btn-light" onClick={(e) => this.handleClear()}><i className="fa fa-refresh me-1"></i>Clear</button>
                                                    </div>
                                                    <div className="d-flex align-items-center" style={{ minHeight: 38 }}>
                                                        <label className="d-inline-flex align-items-center text-nowrap mb-0" style={{ cursor: 'pointer' }}>
                                                            <input className="me-2" type="checkbox"
                                                                checked={this.state.isSendMail}
                                                                onChange={(e) => this.setState({ isSendMail: !this.state.isSendMail })}
                                                            />
                                                            Send Mail
                                                        </label>
                                                    </div>
                                                </div>
                                                {(() => {
                                                    // Category / Exhibitor Type columns only when the list returns those fields
                                                    const showCategory = companyList.some(d => d.PaymentType || d.Category)
                                                    const showExhType = companyList.some(d => d.ExhibitorType)
                                                    return (
                                                        <div className="table-responsive dc-table">
                                                            <table className="table text-nowrap mb-0 sticky-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-center" style={{ width: 50 }}>
                                                                            <input type="checkbox" className="form-check-input m-0"
                                                                                checked={checkedAll}
                                                                                onChange={(e) => this.selectAllCompany(e)}
                                                                            />
                                                                        </th>
                                                                        <th>Reference ID</th>
                                                                        <th>Company</th>
                                                                        {showCategory && <th>Category</th>}
                                                                        {showExhType && <th>Exhibitor Type</th>}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {currentRecords.length > 0 ? currentRecords.map((data) => (
                                                                        <tr key={data.DelegateRegistrationID}>
                                                                            <td className="text-center">
                                                                                <input type="checkbox" className="form-check-input m-0"
                                                                                    checked={data.Is_Select}
                                                                                    onChange={(e) => this.handleCheckedCompany(e, data.DelegateRegistrationID)}
                                                                                />
                                                                            </td>
                                                                            <td>{data.DelegateRegistrationNo}</td>
                                                                            <td>{data.CompanyName}</td>
                                                                            {showCategory && <td>{data.PaymentType || data.Category || '-'}</td>}
                                                                            {showExhType && <td>{data.ExhibitorType || '-'}</td>}
                                                                        </tr>
                                                                    )) : <tr><td colSpan={5} className="text-center">Record not found</td></tr>}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )
                                                })()}
                                                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3">
                                                    {companyList.length > 0 ?
                                                        <Pagination
                                                            nPages={nPages}
                                                            currentPage={currentPage}
                                                            setCurrentPage={this.updateItem}
                                                        /> : <span></span>}
                                                    <span className="text-muted" style={{ fontSize: 13 }}>{`Page ${currentPage} of ${nPages || 1}`}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div >

                <Modal isOpen={isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Confirm Delete</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isDelOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this record?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua" onClick={(e) => this.delCircular(e)}>Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDelOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </Modal>

            </>

        )
    }
}
export default withRouter(connect(null, {
    getDelagateCircularCompany_action, getDelagateCircularList_action, insertUpdateDelagateCircular_action, delDelagateCircular_action, assignCircular_action,
    fill_action
})(AddDelegateCircular))